import { atom } from "recoil";

export const appUserIdAtom = atom<string | null>({
    key: "appUserId",
    default: null
  })